import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "icon", "spinner"]

  confirm(event) {
    // Show spinner, hide icon
    this.iconTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")

    // Change background to green
    this.buttonTarget.classList.remove("bg-gray-100")
    this.buttonTarget.classList.add("bg-green-500")

    // Disable button to prevent double-clicks
    this.buttonTarget.disabled = true
  }

  reset() {
    // Hide spinner, show icon
    this.spinnerTarget.classList.add("hidden")
    this.iconTarget.classList.remove("hidden")

    // Reset background color
    this.buttonTarget.classList.remove("bg-green-500")
    this.buttonTarget.classList.add("bg-gray-100")

    // Re-enable button
    this.buttonTarget.disabled = false
  }
}
